import Vuex from 'vuex';
import { Vue } from '../startup';
import { addTheme } from '../libs/helpers';
import Quotation from './modules/Quotation';
import Preinvoice from './modules/Preinvoice';
import Tutorial from './modules/Tutorial';
import Activity from './modules/activity';
import Order from './modules/Order';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    layout: 'GeneralLayout',
  },
  getters: {},
  mutations: {
    SET_LAYOUT(state, newLayout) {
      state.layout = newLayout;
      addTheme(newLayout);
    },
  },
  actions: {},
  modules: {
    Quotation,
    Preinvoice,
    Tutorial,
    Activity,
    Order,
  },
});
